import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

import { ImportFileInfo } from '../local-import.interface';

@Component({
  host: { 'test-id': 'local-import-progress-card' },
  selector: 'local-import-progress-card',
  styleUrls: ['./local-import-progress-card.component.scss'],
  templateUrl: './local-import-progress-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocalImportProgressCardComponent {
  @Input() filesInfo: ImportFileInfo[] = [];
  @Input() failedFiles: number;
  @Input() progressBarValue: number;
  @Input() completedFiles: number;
  @Input() remainingTimeMessage: string;

  get progressBarColor(): ThemePalette {
    return this.progressBarValue === 100 ? (this.failedFiles > 0 ? 'warn' : 'accent') : 'primary'
  }
}
